/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/components/StickyHeader/NewHeader.tsx
*/

import React, { useState, useEffect } from 'react';

import {
  MainHeader,
  HeaderRoot,
  LogoOne,
  LogoTwo,
  StyledLink,
  LogoOneDiv,
  NavigationItem,
  BulbWrapper,
} from './Header.css';
import { Bulb, BulbOff } from '../../shared/Svg';

import { useRecoilState } from 'recoil';
import { userState } from '../../../recoil/atoms/userAtoms';
import DialogPanel from '../../dialogs/DialogPanel';

const Header = () => {
  const [scrollYPos, setScrollYPos] = useState(0);
  const [user, setUser] = useRecoilState(userState);

  useEffect(() => {
    const handleSetScroll = () => setScrollYPos(document.documentElement.scrollTop);

    window.addEventListener('scroll', handleSetScroll);
    return () => window.removeEventListener('scroll', handleSetScroll);
  }, [scrollYPos, setScrollYPos]);

  const handleToggleLights = () => {
    setUser({
      ...user,
      isLightsOn: !user.isLightsOn,
    });
  };

  useEffect(() => {
    const handleSetScroll = () => setScrollYPos(document.documentElement.scrollTop);

    window.addEventListener('scroll', handleSetScroll);
    return () => window.removeEventListener('scroll', handleSetScroll, false);
  }, [scrollYPos, setScrollYPos]);

  console.log(scrollYPos);

  return (
    <>
      <HeaderRoot>
        <MainHeader>
          <StyledLink href="/#" variant="large">
            <LogoOneDiv>
              <LogoOne>E</LogoOne>
            </LogoOneDiv>
            <LogoTwo isVisible={scrollYPos === 0}>Elrom</LogoTwo>
          </StyledLink>
        </MainHeader>
        <NavigationItem>
          <BulbWrapper onClick={handleToggleLights}>
            {user.isLightsOn ? <Bulb /> : <BulbOff />}
          </BulbWrapper>
        </NavigationItem>
        <DialogPanel isVisible={true} />
      </HeaderRoot>
    </>
  );
};

export default Header;
